import useSearchMutaion from '../../../hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../hooks/apis/useSaveMutaion';
import useDeleteMutation from '../../../hooks/apis/useDeleteMutaion';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import { mapParamsBySchema, mapRowsBySchema } from '../../../util';
import { HEL_BASIC_Schema } from './HEL_BASIC_Schema';

export const useSearch1 = (successOptions = {}) =>
  useSearchMutaion((context) => {
    const params = mapParamsBySchema(HEL_BASIC_Schema.mapper.search1, context);
    return apiRequest('post', Global.urls.HelpDesk.getHelBasicR1, params);
  }, successOptions);

export const useSearch2 = (successOptions = {}) =>
  useSearchMutaion((context) => {
    const params = mapParamsBySchema(HEL_BASIC_Schema.mapper.search2, context);
    return apiRequest('post', Global.urls.HelpDesk.getHelBasicR2, params);
  }, successOptions);

export const useSearch3 = (successOptions = {}) =>
  useSearchMutaion((context) => {
    const params = mapParamsBySchema(HEL_BASIC_Schema.mapper.search3, context);
    return apiRequest('post', Global.urls.HelpDesk.getHelBasicR3, params);
  }, successOptions);

export const useSave1 = (options = {}) =>
  useSaveMutation((rows, context = {}) => {
    const payload = mapRowsBySchema(rows, HEL_BASIC_Schema.mapper.save1, context);
    return apiRequest('post', Global.urls.HelpDesk.saveHelBasicU1, payload);
  }, options);

export const useSave2 = (options = {}) =>
  useSaveMutation((rows, context = {}) => {
    const payload = mapRowsBySchema(rows, HEL_BASIC_Schema.mapper.save2, context);
    return apiRequest('post', Global.urls.HelpDesk.saveHelBasicU2, payload);
  }, options);

export const useSave3 = (options = {}) =>
  useSaveMutation((rows, context = {}) => {
    const payload = mapRowsBySchema(rows, HEL_BASIC_Schema.mapper.save3, context);
    return apiRequest('post', Global.urls.HelpDesk.saveHelBasicU3, payload);
  }, options);

export const useDelete1 = (options = {}) =>
  useDeleteMutation((rows, context = {}) => {
    const payload = mapRowsBySchema(rows, HEL_BASIC_Schema.mapper.delete1, context);
    return apiRequest('post', Global.urls.HelpDesk.deleteHelBasicD1, payload);
  }, options);
